import env, { apiConfig, isLocal } from './runtimeConfig';

export type ApiNamespace =
  | 'auth'
  | 'collections'
  | 'foc'
  | 'insight'
  | 'ingest'
  | 'layout'
  | 'masterId'
  | 'metadataStorage'
  | 'metadataTracker'
  | 'playback'
  | 'profile'
  | 'providers'
  | 'titles'
  | 'workflows';

export const apiMap: Record<ApiNamespace, string> = {
  auth: 'auth',
  collections: 'collections',
  foc: 'foc',
  insight: 'insight',
  ingest: 'ingest',
  layout: 'layout',
  masterId: 'master-id',
  metadataStorage: 'metadatastorage',
  metadataTracker: 'metadatatracker',
  playback: 'playback',
  profile: '',
  providers: 'providers',
  titles: 'titles',
  workflows: 'workflows',
};

export const apiPorts: Record<ApiNamespace, number> = {
  auth: 5040,
  collections: 5090,
  foc: 5300,
  insight: 5200,
  ingest: 5400,
  layout: 5140,
  masterId: 5050,
  metadataStorage: 5000,
  metadataTracker: 5120,
  playback: 5070,
  profile: 5160,
  providers: 5190,
  titles: 5030,
  workflows: 5110,
};

const envConfig = apiConfig[env];

const cdnCacheApiUrl =
  (isLocal ? import.meta.env.VITE__CDN_CACHE_API_URL : envConfig?.cdnCacheApi?.url) ?? '';

const cdnCacheApiKey =
  (isLocal ? import.meta.env.VITE__CDN_CACHE_API_KEY : envConfig?.cdnCacheApi?.key) ?? '';

const apiUrl = (isLocal ? import.meta.env.VITE__API_URL : envConfig?.api.url) ?? '';
const apiKey = (isLocal ? import.meta.env.VITE__API_KEY : envConfig?.api.key) ?? '';

const imageOriginUrl =
  (isLocal
    ? (import.meta.env.VITE__IMAGE_ORIGIN_URL ?? import.meta.env.VITE__API_URL)
    : (envConfig?.cdn?.url ?? envConfig?.api.url)) ?? '';

const imageOriginKey =
  (isLocal
    ? (import.meta.env.VITE__IMAGE_ORIGIN_KEY ?? import.meta.env.VITE__API_KEY)
    : (envConfig?.cdn?.key ?? envConfig?.api.key)) ?? '';

export { apiKey, apiUrl, cdnCacheApiKey, cdnCacheApiUrl, imageOriginKey, imageOriginUrl };
